import { connect } from 'react-redux';
import Playlist from './playlist.component';
import * as PlaylistActions from './playlist.actions';
const mapStateToProps = (state, ownProps) => {
	const { imageServer } = state.WebView.medscape.config;
    const props = Object.assign({
        routing: state.WebView.isIframe === false,
        configs: state.Playlist.items.map( item => {
            return Object.assign({},item,{
                "thumbnail": `${imageServer.host}${item.thumbnail}`
            })
        }),
        playedItems: state.Playlist.playedItems
    },ownProps);
    return props;
};

const mapDispatchToProps = dispatch => {
    return {
        onIfiItemClick: (el) =>{
            dispatch(PlaylistActions.clickIfi(el));
        },
        onEpisodeItemClick: (el) => {
            dispatch(PlaylistActions.clickEpisode(el));
        },
        onSliderBeforeChange: (oldIndex, newIndex) => {
            dispatch(PlaylistActions.sliderBeforeChange(oldIndex,newIndex));
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(Playlist);